import { AlbumArt } from './AlbumArt';
import { Music, Pause, Play } from 'lucide-react';
import { Album } from '../albumList/album';
import { coverArtUrl } from '../../../config/images';
import './Cards.css';

interface Props {
    album: Album;
    artistName?: string;
    onClick: (album: Album) => void;
    onPlay?: (album: Album) => void;
    isPlaying?: boolean;
}

export function AlbumCard({ album, artistName, onClick, onPlay, isPlaying }: Props): React.JSX.Element {
    const art = coverArtUrl(album.getId());

    return (
        <div className="gridCard" onClick={() => onClick(album)}>
            <div className="gridCardArt">
                {art ? (
                    <AlbumArt img={art} title={album.getTitle()} />
                ) : (
                    <Music size={28} strokeWidth={2.75} />
                )}
                {onPlay && (
                    <button
                        className={`gridCardPlayButton ${isPlaying ? 'gridCardPlayButtonVisible' : ''}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            onPlay(album);
                        }}
                        aria-label={isPlaying ? `Pause ${album.getTitle()}` : `Play ${album.getTitle()}`}
                    >
                        {isPlaying ? (
                            <Pause size={16} strokeWidth={2.75} fill="currentColor" />
                        ) : (
                            <Play size={16} strokeWidth={2.75} fill="currentColor" />
                        )}
                    </button>
                )}
            </div>
            <div className="gridCardMeta">
                <span className="gridCardTitle">{album.getTitle()}</span>
                {artistName && <span className="gridCardSubtitle">{artistName}</span>}
                {/* Album-level credited artists (fallback handled by artistName above) */}
                {album.getReleaseYear() && (
                    <span className="gridCardMuted">
                        {album.getReleaseYear()}
                        {album.getPrimaryType() && album.getPrimaryType() !== 'Album'
                            ? ` · ${album.getReleaseTypeLabel()}`
                            : ''}
                    </span>
                )}
            </div>
        </div>
    );
}
